import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  isCollapse: boolean;
};

const initialState: InitialState = {
  isCollapse: false,
};

const searchAreaSlice = createSlice({
  name: "searchArea",
  initialState,
  reducers: {
    setIsCollapse(state, action: PayloadAction<{ isCollapse: boolean }>) {
      state.isCollapse = action.payload.isCollapse;
    },
  },
});

export const { setIsCollapse } = searchAreaSlice.actions;

export default searchAreaSlice;
